import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { SportEquipmentTab, SportEquipmentTabs } from "store/reactiveVarsStores/spor-equipmnts/sportEquipmentTabActive";


interface Props {
  tabActive: SportEquipmentTab;

  actions: {
    setTabActive: (tab: SportEquipmentTab) => void
  };
}

export default (props: Props) => {
  const { actions: { setTabActive }, tabActive } = props;

  const TABS = Object.keys(SportEquipmentTabs).map((key) => SportEquipmentTabs[key]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabActive(TABS.find(tab => tab.id === newValue));
  };

  return (
    <>
      <Tabs
        value={tabActive.id}
        sx={{ px: 3, borderBottom: "1px solid", borderColor: "divider" }}
        onChange={handleChange}
      >
        {TABS.map((tab, index) => (
          <Tab
            key={tab.id}
            disableRipple
            label={
              <Box component={"span"} sx={{ fontSize: 15, fontWeight: "bold" }}>{tab.displayName}</Box>
            }
            value={tab.id}
            onClick={(value) => setTabActive(tab)}
          />
        ))}
      </Tabs>
    </>
  );
};